import { useEffect, useRef } from 'react';

const useInterval = (callback, delay = 0) => {
  const savedCallback = useRef(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    const interval = setInterval(tick, delay);

    return () => clearInterval(interval);
  }, [delay]);
};

export default useInterval;
